'use client';
/* Built In Imports */
// import NextLink from 'next/link';
import { useEffect, useState } from 'react';
/* External Imports */
import { Link } from '@chakra-ui/next-js';
import { Box, Button, Text } from '@chakra-ui/react';

import { format } from 'date-fns';
import parser from 'html-react-parser';
import { nanoid } from 'nanoid';
import { HiOutlineClock } from 'react-icons/hi';
import { IoInformationCircleOutline, IoLocationOutline } from 'react-icons/io5';
import YouTube from 'react-youtube';
/* Internal Imports */
/* Components */
import LazyLoadImageComponent from '@app-ps/Components/Ui/LazyLoadImageComponent';
import { getEmbedUrl, refineUrlDomain } from '@app-ps/Components/Utility/utils';
import config from '@config';

/* Services */
import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';

/**
 * Renders the CalendarTabsCard component
 *
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region of the section
 * @param {string} lang - Language of the section
 * @returns {ReactElement} CalendarTabsCard component
 */
const CalendarTabsCard = ({
  sectionContent,
  id,
  // isProduction,
  address,
  program_url,
  samskriti,
  title,
  filterDate,
  button_label,
  type,
  description,
  category,
  amount,
  date,
  time,
  is_online,
  currency,
  country,
  program_id,
  hasVideo,
  isOnline,
  selTab,
  category_tags,
  urlAlias,
  heroSection,
  heroImage,
  cardCtaLabel,
  pType,
  region,
  lang,
}) => {
  const [opts, setOpts] = useState({}); // Store video options
  const [vidVis, setvidVis] = useState(false);
  const isProdCard = samskriti?.category_tags?.indexOf('Production') > -1;
  const isWorkCard = samskriti?.category_tags?.indexOf('Workshops') > -1;
  // console.log({
  //   type, samskriti,
  // }, 'workcard');
  let displayDate = '';
  // Helper function to get day, month, year and time
  const formatDate = dateStr => {
    const date = new Date(dateStr);
    const day = format(date, 'd');
    const month = format(date, 'MMMM');
    const year = format(date, 'yyyy');
    const time = format(date, 'h:mm a'); // Format time as "5 PM" or "5 AM"
    return { day, month, year, time };
  };

  if (samskriti?.startdate) {
    const {
      day: startDay,
      month: startMonth,
      year: startYear,
      time: startTime,
    } = formatDate(samskriti?.startdate || '');
    const {
      day: endDay,
      month: endMonth,
      year: endYear,
    } = formatDate(samskriti?.enddate || '');

    // Check if start and end date are the same or different
    if (
      startDay === endDay &&
      startMonth === endMonth &&
      startYear === endYear
    ) {
      // Same start and end date
      displayDate = `${startDay} ${startMonth} ${startYear} | ${startTime}`;
    } else {
      // Different start and end dates
      displayDate = `${startDay} - ${endDay} ${startMonth} ${startYear} | ${startTime}`;
    }
  }

  useEffect(() => {
    setOpts({
      height: '100%', // Set height based on your box size
      width: '100%', // Full width of the container
      playerVars: {
        autoplay: 1, // Auto-play the video when it loads
      },
    });
  }, []);
  const videoUrl = samskriti?.featured_video;

  return (
    <Box
      key={nanoid()}
      mt={{ base: '1.5rem' }}
      display={'flex'}
      flexDirection={{ lg: 'row-reverse', base: 'column' }}
      justifyContent={{ lg: 'center' }}
    >
      {/* box for photo */}
      <Box
        // as={Link}
        bgSize="cover"
        bgPosition="center"
        bgImage={
          type === 'past'
            ? (heroImage?.url ||
              heroSection?.images[0]?.image?.url)
            : samskriti?.featured_image.split(',')[0] ||
              samskriti?.featured_image?.replace(/\\/g, '').split(',')[0]
        }
        width={{ base: '100%', md: '100%', lg: '298px', xl: '380px' }}
        minW={{ base: '1', '2xl': '380px' }}
        // maxWidth={{ lg: '374px' }}
        height={{ base: '298px', md: '339px', lg: 'auto' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
        position="relative"
        // href={refineUrlDomain(
        //         program.type === 'past'
        //           ? `productions/${program.urlAlias}`
        //           : `productions/upcoming?id=${program?.program_id}`
        //       )}
        cursor={videoUrl ? 'pointer' : 'auto'}
      >
        {/* {type}- {isProdCard ? '1' : '0'}
        {isProdCard
          ? `productions/upcoming?id=${program_id}`
          : type === 'past'
          ? `productions/${urlAlias}`
          : '#'} */}
        <Box
          bgColor="#090D11"
          color="#FEFAF6"
          opacity="0.7"
          textAlign="center"
          fontWeight={350}
          fontSize={{ base: '0.875rem' }}
          letterSpacing="2%"
          lineHeight={{ base: '1.4rem' }}
          p="0.5rem"
          fontFamily="var(--FedraSansStd-book)"
          position="absolute"
          top={{ base: 'auto', lg: '0rem' }}
          bottom={{ base: '0rem', lg: 'auto' }}
          left={{ base: '0rem', lg: 'auto' }}
          right={{ base: 'auto', lg: '0rem' }}
        >
          {is_online === '1' ? 'Online' : 'In-Person'}
        </Box>
        {!vidVis && videoUrl ? (
          <LazyLoadImageComponent
            src={`${config.imgPath}/d/46272/1720495733-button-play.png`}
            height="70px"
            onClick={() => setvidVis(true)}
            width="70px"
            alt="Play button"
          />
        ) : vidVis ? (
          <Box width="100%" height="100%" position="absolute" top="0" left="0">
            <YouTube
              videoId={getEmbedUrl(videoUrl)}
              opts={opts}
              onReady={event => event.target.playVideo()}
              style={{ width: '100%', height: '100%' }}
            />
          </Box>
        ) : null}
        {/* <LazyLoadImageComponent
          src="https://static.sadhguru.org/d/46272/1720495733-button-play.png"
          height="70px"
          width="70px"
          alt="Play button"
        /> */}
      </Box>

      {/* box container for all text */}
      <Box
        padding={{ base: '1rem' }}
        paddingY={{ md: '2rem' }}
        px={{ md: '2rem' }}
        bgColor={'#0E1216'}
        w="100%"
      >
        {/* box wrapper for text1 and know more*/}
        <Box
          display="flex"
          justifyContent={{ base: 'space-between' }}
          alignItems={{ base: 'center' }}
        >
          <Link
            href={refineUrlDomain(
              isProdCard
                ? `productions/upcoming?id=${program_id}`
                : type === 'past'
                ? `productions/${urlAlias}`
                : '#',
              region,
              lang
            )}
            scroll={false}
            prefetch
          >
            <Box
              // href={
              //   isProdCard
              //     ? `productions/upcoming?id=${program_id}`
              //     : type === 'past'
              //     ? `productions/${urlAlias}`
              //     : '#'
              // }
              lineHeight={{ md: '2rem', base: '1.8rem' }}
              color={'#FEFAF6'}
              letterSpacing={'0.32px'}
              textAlign={{ lg: 'left' }}
              fontWeight={500}
              fontSize={{ base: '1.125rem', md: '1.25rem' }}
              fontFamily="var(--FedraSansStd-medium)"
              _hover={{
                textDecoration: 'none',
              }}
            >
              {title}
              <Box
                fontWeight={350}
                color="#F1EDE9"
                fontFamily="var(--FedraSansStd-book)"
                fontSize={{ base: '0.75rem', md: '1rem' }}
                textTransform="capitalize"
              >
                {samskriti?.category_tags.split(',').join(' | ')}
                {type === 'past' && category}
              </Box>
            </Box>
          </Link>
          {!isWorkCard && (isProdCard || pType === 'calendar') && (
            <Link
              // href={refineUrlDomain(
              //   isProdCard
              //     ? `productions/upcoming?id=${program_id}`
              //     : type === 'past'
              //     ? `productions/${urlAlias}`
              //     : '#',
              //   region,
              //   lang
              // )}
              href={refineUrlDomain(
                `productions/upcoming?id=${program_id}`,
                region,
                lang
              )}
              scroll={false}
              // legacyBehavior
              prefetch
            >
              <Text
                // color={'#F18128'}
                color={
                  isProdCard || type === 'past'
                    ? '#F18128'
                    : isWorkCard
                    ? '#EDA807'
                    : '#F18128'
                }
                whiteSpace={{ lg: 'nowrap' }}
                letterSpacing={'0.32px'}
                lineHeight={{ md: '1.6rem', base: '1.4rem' }}
                fontWeight={500}
                fontSize={{ base: '1.125rem', md: '1rem' }}
                fontFamily="var(--FedraSansStd-medium)"

                // href={refineUrlDomain(`productions/upcoming?id=${program_id}`)}
              >
                {/* Text is hidden on base and shown on larger screens */}
                <Box display={{ base: 'none', lg: 'inline' }}>Know More</Box>

                {/* Icon is shown on base and hidden on larger screens */}
                <Box display={{ base: 'inline', lg: 'none' }}>
                  <IoInformationCircleOutline />
                </Box>
              </Text>
            </Link>
          )}
        </Box>
        {/* box for text 2 */}
        <Box
          fontWeight={350}
          fontFamily="var(--FedraSansStd-book)"
          letterSpacing={'0.32px'}
          opacity={'0.8'}
          textAlign="left"
          color={'#F1EDE9'}
          mt={{ base: '1rem', lg: '2rem' }}
          fontSize={{ base: '0.875rem', md: '1.125rem' }}
          lineHeight={{ md: '1.8rem', base: '1.4rem' }}
          sx={{
            ul: {
              paddingLeft: '20px',
            },
          }}
        >
          {parser(samskriti?.short_description || '')}
        </Box>

        {/* box for text3 and button */}
        <Box
          mt={{ base: '1.5rem', lg: '5rem' }}
          display={{ base: 'flex' }}
          flexDirection={{ base: 'column', lg: 'row' }}
          justifyContent={{ lg: 'space-between' }}
          alignItems={{ lg: 'end' }}
          gap={{ lg: '7', base: '1rem' }}
        >
          <Box
            display={'flex'}
            alignItems={'center'}
            letterSpacing={'0.32px'}
            lineHeight={{ md: '1.8rem', base: '1.4rem' }}
            fontFamily="var(--FedraSansStd-book)"
            color={'#FEFAF6'}
            fontSize={{ base: '0.875rem', md: '1rem' }}
          >
            <Box>
              {/* additional box */}
              {type !== 'past' && (
                <Box
                  textAlign={{ base: 'left' }}
                  display="flex"
                  gap={{ base: '0.5rem' }}
                  alignItems={{ base: 'flex-start' }}
                  mb="5px"
                >
                  {/* <PiGlobeSimpleDuotone fontSize="24px" />
                <IoLocationOutline fontSize="24px" /> */}
                  {is_online === '1' ? (
                    <LazyLoadImageComponent
                      src={`${config.imgPath}/d/46272/1723466202-icon.png`}
                      w="24px"
                      h="24px"
                      p="2px"
                      mt={{ md: '5px' }}
                    />
                  ) : (
                    <IoLocationOutline mt={{ md: '5px' }} fontSize="24px" />
                  )}
                  {/* {is_online === '1'
                  ? samskriti?.popup_description
                  : `${address}, ${country}`}{' '} */}
                  {is_online === '1'
                    ? samskriti?.popup_description
                    : `${address ? address : ''}${
                        address && country ? ', ' : ''
                      }${country ? country : ''}`}
                </Box>
              )}

              {displayDate && (
                <Box
                  display="flex"
                  alignItems={{ base: 'flex-start' }}
                  gap={{ base: '0.5rem' }}
                >
                  <HiOutlineClock
                    fontSize="24px"
                    style={{ marginTop: '3px' }}
                  />
                  {displayDate}
                </Box>
              )}
              {samskriti?.Session && (
                <Box
                  alignItems={{ base: 'flex-start' }}
                  display="flex"
                  gap={{ base: '.5rem' }}
                >
                  <FiClock
                    fontSize={{ base: '1.125rem' }}
                    style={{ marginTop: '3px' }}
                  />
                  {samskriti?.Session}
                </Box>
              )}
            </Box>
          </Box>
          {/*wrapper for price and button  */}
          <Box
            display="flex"
            // flexDirection={{ lg: 'row', base: 'column' }}
            flexDirection={{ base: 'column', lg: 'row' }}
            gap={{ lg: '.8rem' }}
            alignItems={{ lg: 'end' }}
          >
            <Box
              // as={Link}
              // href={'#'}
              color={'#FEFAF6'}
              textAlign={{ lg: 'right', base: 'left' }}
              lineHeight={{ base: '1.8rem' }}
              letterSpacing={'0.32px'}
              fontWeight={500}
              fontSize={{ base: '1.125rem' }}
              fontFamily="var(--FedraSansStd-medium)"
              _hover={{
                textDecoration: 'none',
              }}
            >
              <Box display="flex" gap={{ base: '.4rem' }}>
                <Text>{currency}</Text>
                {amount}
              </Box>
            </Box>

            <Button
              // px={{ base: '2rem' }}
              mt={{ base: '1.5rem', lg: '0' }}
              textAlign={'center'}
              width={{ lg: '192px', sm: '296px', md: '100%', base: '100%' }}
              height={{ base: '50px' }}
              boxSizing="border-box"
              // py={{ base: '12px' }}
              // bgColor={'#EDA807'}
              bgColor={isProdCard || type === 'past' ? '#F18128' : '#EDA807'}
              fontFamily={'var(--FedraSansStd-medium)'}
              borderRadius={'none'}
              _hover={{
                bgColor: '#F18128', // Sets the background color on hover
                textDecoration: 'none',
              }}
              as={Link}
              prefetch
              fontWeight={500}
              fontSize={{ base: '1rem', md: '1rem' }}
              letterSpacing={'0.32px'}
              color={'#010509'}
              href={
                type === 'past'
                  ? refineUrlDomain(`productions/${urlAlias}`)
                  : samskriti?.register_url
              }
            >
              {/* {button_label} */}
              {type !== 'past' ? cardCtaLabel || 'REGISTER NOW' : 'KNOW MORE'}
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};
export default CalendarTabsCard;
